import { AuthContext } from '@repo-level/core-front';
import useEventListener from '@repo-level/core-front/hooks/eventListener';
import { Logo } from 'components/Logo';
import { AddonsContext } from 'contexts/addons';
import { useMedia } from 'modules/common/hooks/useMedia';
import { useContext, useMemo, useRef, useState } from 'react';
import { useCurrentRoute } from 'react-navi';
import { UserWallets } from '../UserWallets';
import { ScMobileHeader } from './styled';

const noHeaderPages = ['search-games'];

export const HeaderMobile = () => {
  const {
    url: { pathname },
  } = useCurrentRoute();

  const { isEmailConfirmationPopup, emailConfirmationPopupHeight } =
    useContext(AddonsContext);

  const ref = useRef<HTMLDivElement | null>(null);
  const [isTop, setIsTop] = useState(true);

  const { isMobile } = useMedia();
  const { isAuthenticated } = useContext(AuthContext);

  const noHeader = useMemo(
    () => noHeaderPages.includes(pathname.split('/')[1]),
    [pathname]
  );

  useEventListener('scroll', () => setIsTop(window.scrollY <= 20));

  return !isMobile || noHeader ? null : (
    <ScMobileHeader
      emailConfirmationPopupHeight={emailConfirmationPopupHeight}
      isAuth={isAuthenticated}
      isTop={isTop}
      ref={ref}
      withEmailConfirmationPopup={isEmailConfirmationPopup}
    >
      <Logo height={isAuthenticated ? 24 : 32} smallLogo={isAuthenticated} />
      {isAuthenticated && (
        <div className="wallet">
          <UserWallets />
        </div>
      )}
    </ScMobileHeader>
  );
};
